export const ADVANCE_DECLINE = "ADVANCE_DECLINE";
export const ADVANCE_DECLINE_STREAM = "ADVANCE_DECLINE_STREAM";
export const ADVANCE_DECLINE_ERROR = "ADVANCE_DECLINE_ERROR";
export const ADVANCE_DECLINE_HIDE_ERROR = "ADVANCE_DECLINE_HIDE_ERROR";
export const ADVANCE_DECLINE_START_LOADER = "ADVANCE_DECLINE_START_LOADER";
export const ADVANCE_DECLINE_STOP_LOADER = "ADVANCE_DECLINE_STOP_LOADER";
